const HIGHLIGHTED_CHIP_CLASS_NAME = 'highlighted-chip';
export const GRAY_DELETABLE_CHIP_CLASS_NAME = 'gray-deletable-chip';

export default HIGHLIGHTED_CHIP_CLASS_NAME;
